/**
 * Module dependencies.
 */

import { css } from '@emotion/react';
import { ifNotProp } from 'styled-tools';
import Link from 'next/link';
import styled from '@emotion/styled';

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled(Link)`
  color: #000000;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;

  ${ifNotProp(
    'ghost',
    css`
      &:hover {
        text-decoration: underline;
      }
    `,
  )}
`;
